import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import StyledBox from 'views/rebranded-module/common/components/UI/CounterV2/CounterV2.styles';

const CounterV2 = ({
  count,
  min,
  max,
  onIncrement,
  onDecrement,
  inactive,
  title,
  incrementTestId,
  decrementTestId,
}) => (
  <>
    <StyledBox>
      <Box className="CV2CountContainer">
        <Typography className="CV2Text" variant="body2">
          {count}
        </Typography>
      </Box>
      <Box>
        <Typography className="CV2Text" variant="body2">
          {title}
        </Typography>
      </Box>
      <Box>
        <IconButton
          className="CV2Btn"
          onClick={onDecrement}
          disableRipple={false}
          data-testid={decrementTestId}
          disabled={inactive || (min != null ? count <= min : false)}>
          <RemoveIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box>
        <IconButton
          className="CV2Btn"
          onClick={onIncrement}
          disableRipple={false}
          data-testid={incrementTestId}
          disabled={inactive || (max != null ? count >= max : false)}>
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>
    </StyledBox>
  </>
);

export { CounterV2 };
